import { render, staticRenderFns } from "./QType1.vue?vue&type=template&id=352de16a&scoped=true&"
import script from "./QType1.vue?vue&type=script&lang=js&"
export * from "./QType1.vue?vue&type=script&lang=js&"
import style0 from "./QType1.vue?vue&type=style&index=0&id=352de16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352de16a",
  null
  
)

export default component.exports